module.exports = __webpack_public_path__ + "assets/img/checked2-599a0112.png";